module.exports = __webpack_public_path__ + "img/woman-border-green.b37efc93.svg";